import type { ModuleCode } from "./types";

export interface ModuleDefinition {
  code: ModuleCode;
  name: string;
  description: string;
  isEnterprise: boolean;
  /** Module-level config keys the UI should expose. */
  configFields?: string[];
}

/**
 * Catalog mirroring the `modules` table seeded by Alembic (0002_seed_modules).
 * Keep in sync with apps/api/alembic/versions/0002_seed_modules.py.
 */
export const MODULE_CATALOG: ModuleDefinition[] = [
  {
    code: "faq",
    name: "FAQ",
    description: "Answer frequently asked questions with configurable items.",
    isEnterprise: false,
    configFields: ["welcome_message", "fallback_message", "farewell_message", "farewell_keywords", "faq_items", "tone", "language"],
  },
  {
    code: "lead_capture",
    name: "Lead Capture",
    description: "Collect commercial contact information from customers.",
    isEnterprise: false,
    configFields: [
      "collect_name",
      "collect_email",
      "collect_phone",
      "collect_company",
      "custom_fields",
      "required_fields",
      "success_message",
    ],
  },
  {
    code: "human_escalation",
    name: "Human Escalation",
    description: "Transfer conversations to a human operator.",
    isEnterprise: false,
    configFields: [
      "business_hours",
      "escalation_keywords",
      "transfer_message",
      "notify_channel",
    ],
  },
  {
    code: "scheduling",
    name: "Scheduling",
    description: "Book, reschedule, and cancel appointments.",
    isEnterprise: false,
    configFields: [
      "appointment_duration",
      "available_days",
      "available_hours",
      "timezone",
      "buffer_time",
      "max_daily_appointments",
    ],
  },
  {
    code: "conversational_ai",
    name: "Conversational AI",
    description: "Open-ended question answering using language models.",
    isEnterprise: false,
    configFields: [
      "provider",
      "model",
      "system_prompt",
      "temperature",
      "top_p",
      "max_tokens",
      "conversation_memory",
      "return_keywords",
      "return_message",
    ],
  },
  {
    code: "analytics",
    name: "Analytics",
    description: "Track usage and behavior; surface dashboards.",
    isEnterprise: false,
    configFields: ["retention_days", "metrics_to_track", "dashboard_visibility"],
  },
  {
    code: "knowledge_base",
    name: "Knowledge Base (Enterprise)",
    description: "RAG over customer-specific documents.",
    isEnterprise: true,
  },
  {
    code: "integrations",
    name: "Integrations (Enterprise)",
    description: "Connect the bot to external systems (CRM, ERP, etc.).",
    isEnterprise: true,
  },
];

export function getModule(code: ModuleCode): ModuleDefinition | undefined {
  return MODULE_CATALOG.find((m) => m.code === code);
}
